import { useEffect } from 'react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { LabelV2VersionAudioFormComponentProps } from './types';
import { useLabelV2VersionAudio } from './hooks';
import { LabelV2VersionAudioForm } from './LabelV2VersionAudioForm';

export const LabelV2VersionAudioComponent = (
  props: LabelV2VersionAudioFormComponentProps
) => {
  const {
    primaryAudio,
    fetchAudioDetailsValidations,
    updateAudioValidations,
  } = props;
  const formProps = useLabelV2VersionAudio(props);

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <LabelV2VersionAudioForm {...formProps} />
    </ContentContainer>
  );
};
